import ModalShareCartTrigger from "../components/share-cart/modal-share-cart/presenter/modal-share-cart-trigger.js";

const shareCartTrigger = document.querySelector(`.button_share-cart`);

if (shareCartTrigger) {
  const modalShareCartTriggerComponent = new ModalShareCartTrigger(shareCartTrigger);
  modalShareCartTriggerComponent.init();
}
